import { useInsertionEffect, useRef, type RefObject } from 'react';

/**
 * Keep a ref up-to-date with a changing value, so that the latest _committed_
 * value is always available.
 */
export function useLatestRef<T>(value: T): RefObject<T> {
    const ref = useRef(value);

    // We can't update the ref in the render function directly (per React docs),
    // because not all renders are committed, thus we risk saving a ref here
    // from an uncommitted render. We update it in `useInsertionEffect` so that
    // it is guaranteed to be updated before any `useLayoutEffect` and
    // `useEffect` runs.
    useInsertionEffect(() => {
        ref.current = value;
    }, [value]);

    return ref;
}
